import React from 'react';
import { useState, useEffect } from 'react';
import api from '../services/api';

/*
  ProteccionDatosModal — genera un consentimiento del sistema genérico
  (plantillas_consentimiento / consentimientos_informados), típicamente
  la plantilla de protección de datos (LOPDP). Mismo patrón controlado
  que RecetaModal.jsx / Form024Modal.jsx.

  Si solo existe una plantilla activa, se preselecciona sola -- el
  odontólogo no tiene que elegir nada, solo confirmar.
*/
export default function ProteccionDatosModal({ codPacienteInicial, onGuardado, onCerrar }) {
  const [plantillas, setPlantillas] = useState(null); // null = cargando
  const [plantillaSel, setPlantillaSel] = useState('');
  const [procedimiento, setProcedimiento] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/historia/plantillas-consentimiento')
      .then(({ data }) => {
        setPlantillas(data || []);
        if (data?.length === 1) setPlantillaSel(String(data[0].COD));
      })
      .catch(() => setPlantillas([]));
  }, []);

  const guardar = async () => {
    setError('');
    if (!plantillaSel) { setError('Elige una plantilla'); return; }
    setGuardando(true);
    try {
      const { data } = await api.post('/historia/consentimientos', {
        COD_PACIENTE: codPacienteInicial,
        COD_PLANTILLA: plantillaSel,
        PROCEDIMIENTO_ESPECIFICO: procedimiento || null,
      });
      const { data: pdfBytes } = await api.get(`/historia/consentimientos/${data.COD}/pdf`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([pdfBytes], { type: 'application/pdf' }));
      window.open(url, '_blank');
      onGuardado?.();
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo generar el consentimiento');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className="pd-overlay" onClick={onCerrar}>
        <div className="pd-card" onClick={e => e.stopPropagation()}>
          <div className="pd-hdr">
            <span><i className="ti ti-shield-lock" aria-hidden="true"></i> Protección de datos</span>
            <button className="pd-close" onClick={onCerrar} title="Cerrar"><i className="ti ti-x" aria-hidden="true"></i></button>
          </div>

          <div className="pd-body">
            {error && <div className="pd-error"><i className="ti ti-alert-circle" aria-hidden="true"></i> {error}</div>}

            {plantillas === null ? (
              <p className="pd-hint">Cargando plantillas...</p>
            ) : plantillas.length === 0 ? (
              <p className="pd-hint">
                Todavía no hay ninguna plantilla de consentimiento activa. Crea una en
                Configuración → Consentimientos (por ejemplo, "Tratamiento de datos personales").
              </p>
            ) : (
              <>
                {plantillas.length > 1 && (
                  <>
                    <div className="mo-sec">Plantilla</div>
                    <select className="form-control" value={plantillaSel} onChange={e => setPlantillaSel(e.target.value)}>
                      <option value="">Elige una...</option>
                      {plantillas.map(p => <option key={p.COD} value={p.COD}>{p.TITULO}</option>)}
                    </select>
                  </>
                )}
                {plantillas.length === 1 && (
                  <p className="pd-hint">Se usará la plantilla: <b>{plantillas[0].TITULO}</b></p>
                )}

                <div className="mo-sec" style={{ marginTop: 10 }}>Detalle específico (opcional)</div>
                <input className="form-control" placeholder="Ej: datos clínicos y de contacto"
                  value={procedimiento} onChange={e => setProcedimiento(e.target.value)} />

                <button className="btn-mo-pri pd-guardar" disabled={guardando} onClick={guardar}>
                  <i className="ti ti-file-check" aria-hidden="true"></i> {guardando ? 'Generando...' : 'Generar consentimiento (PDF)'}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const css = `
.pd-overlay { position:fixed; inset:0; background:rgba(15,20,30,.45); display:flex; align-items:flex-start; justify-content:center; padding:32px 16px; z-index:200; overflow-y:auto; }
.pd-card { background:var(--surface); border-radius:14px; width:100%; max-width:440px; overflow:hidden; box-shadow:0 12px 32px rgba(0,0,0,.18); }
.pd-hdr { display:flex; align-items:center; justify-content:space-between; padding:14px 18px; background:var(--navy); color:#fff; font-size:14px; font-weight:700; }
.pd-hdr i { margin-right:6px; }
.pd-close { background:none; border:none; color:#fff; cursor:pointer; font-size:16px; opacity:.85; }
.pd-close:hover { opacity:1; }
.pd-body { padding:16px 18px 20px; }
.pd-hint { font-size:12.5px; color:var(--text2); line-height:1.5; }
.pd-error { background:var(--red-lt); color:var(--red); border:1px solid var(--red); border-radius:8px; padding:8px 12px; font-size:12px; margin-bottom:10px; display:flex; align-items:center; gap:6px; }
.pd-guardar { width:100%; margin-top:14px; }
`;
